// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._18m915vq{overflow-y:hidden}
._1bsb1osq{width:100%}
._1bto1l2s{text-overflow:ellipsis}
._1reo15vq{overflow-x:hidden}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/renderer/node_modules/@atlaskit/link-datasource/dist/esm/ui/issue-like-table/shared-components/icon/index.compiled.css"],"names":[],"mappings":"AAAA,WAAW,iBAAiB;AAC5B,WAAW,UAAU;AACrB,WAAW,sBAAsB;AACjC,WAAW,iBAAiB","sourcesContent":["._18m915vq{overflow-y:hidden}\n._1bsb1osq{width:100%}\n._1bto1l2s{text-overflow:ellipsis}\n._1reo15vq{overflow-x:hidden}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
